import { Component, inject } from '@angular/core';
import { FeatureFlags } from '@common/constant';
import { FeatureFlagService } from '@common/services/feature-flag.service';

@Component({
  selector: 'pl-quick-links-card',
  templateUrl: './quick-links-card.component.html',
  styleUrls: ['./quick-links-card.component.scss'],
})
export class QuickLinksCardComponent {
  private readonly featureFlagService = inject(FeatureFlagService);

  readonly hideExternalTools$ = this.featureFlagService.isFeatureEnabled(
    FeatureFlags.HIDE_EXTERNAL_TOOLS
  );
}
